<template>

    <ArticleSection>
        <div class="articleTop" :class="{'articleTop-dark': isDark, 'articleTop-half': isHalf}" v-hammer:swipe.up="scrollDown">
            <ButtonSound v-if="sound" v-bind="sound"></ButtonSound>
            <div v-if="imageCaption" v-html="imageCaption" class="articleTop_caption">
            </div>
            <div class="articleTop_image"
                 ref="articleTop_image"
                 :style="{'background-image': 'url(' + imgPath(image) + ')', 'background-position': imageOffset}"
            >
                <ImageZoomable
                        ref="imageZoomable"
                        :src="image"
                        :bgPos="imageOffset"
                        v-if="showImageZoomable"
                        noAppearEffect
                        @zoomed="onZoomHandler"
                        @unzoomed="onUnZoomHandler"
                />
            </div>
            <div class="articleTop_content" ref="articleTop_content">
                <h1 v-moving-line v-html="title" :class="{'reduceSize': isReduce}"></h1>
                <h2>{{ subTitle }}</h2>
                <div v-if="intro" ref="articleTop_content_intro" class="articleTop_content_intro" v-html="intro">
                </div>
                <Author :name="authorName"
                        :title="authorTitle"
                        :image="authorImage"
                        :quote="authorQuote"
                        ref="author"
                ></Author>
                <div v-if="experts" class="articleTop_content_expert">
                    <AuthorList :experts="experts" ref="expert"></AuthorList> 
                </div>
                <slot></slot>
            </div>
        </div>

        <Scrolldown @click.native="scrollDown()"></Scrolldown>
    </ArticleSection>

</template>

<script>
    import ArticleSection from "./ArticleSection";
    import Author from "./Author";
    import AuthorList from "./AuthorList";
    import {TimelineMax, Expo} from "gsap/TweenMax";
    import Scrolldown from "./Scrolldown";
    import ButtonSound from "./ButtonSound";
    import {Device, EBreakPoint} from "../utils/Device";
    import ImageZoomable from "./ImageZoomable";
    export default {
        name: 'ArticleTop',
        components: {ImageZoomable,ButtonSound, Scrolldown, Author, ArticleSection, AuthorList},
        props: ['sound', 'image', 'imageOffset', 'authorOffset', 'title', 'subTitle', 'intro', 'authorName', 'authorImage', 'authorQuote' , 'authorTitle', 'animationType', 'imageCaption', 'experts', 'isReduce'],
        data: function(){
            return {
                isDark: false,
                showImageZoomable: false,
                isHalf: false,
            };
        },
        mounted: function(){
            //this.$events.listen('page-scrolling', this.reduce);
            this.$events.fire('page-lockScroll');
            // on réduit la page que si on est en mode suppérieur a SM
            if(Device.isUpTo(EBreakPoint.SM)){
                setTimeout(() => {
                    this.reduce();
                }, 1000);
            }
            //console.log('mounted');
        },

        methods: {
            onZoomHandler: function(){
                TweenMax.to(this.$refs.articleTop_content, 0.5, {alpha: 0});
            },
            onUnZoomHandler: function(){
                TweenMax.to(this.$refs.articleTop_content, 0.5, {alpha: 1});
            },
            imgPath: function(img){
                return require('../assets/img/'+img);
            },
            reduce: function() {
                // pas besoin de relancer la tween si on est déja en mode dark
                if(this.isDark) return;
                this.isDark = true;
                let t = new TimelineMax();


                if (this.animationType == "half_anim") {
                    this. isHalf = true;
                    let left_img = 0;
                    t.to(this.$refs.articleTop_image, 1, {width: '50%', left: left_img, ease: Expo.easeInOut});
                }
                else {
                    let left_img = Device.vp.w*0.3;
                    t.to(this.$refs.articleTop_image, 1, {width: '20%', left: left_img, ease: Expo.easeInOut});
                    t.add(() => {this.showImageZoomable = true;})
                }

                let author = this.$refs.author.$el;
                TweenMax.to(author, 1, {
                    delay: 0.5,
                    opacity: 1,
                    ease: Expo.easeInOut,
                });

                if('expert' in this.$refs){
                    let expert = this.$refs.expert.$el;
                    TweenMax.to(expert, 1, {
                        delay: 0.5,
                        opacity: 1,
                        ease: Expo.easeInOut,
                    })
                }

            },
            scrollDown: function(){
                this.$events.fire('page-scrollSection', {nb: 1});
                this.$events.fire('page-unlockScroll');
                if('imageZoomable' in this.$refs){
                    this.$refs.imageZoomable.unzoom();
                }
            },
        }
    };
</script>

<style scoped lang="scss">
    .articleTop{
        min-height: 100vh;
        position: relative;
        color: #fff;
        margin: -$G-default 0;

        & > *{
            @include transition(color, 1s);
        }

        &-dark{
            color: #000;
            & > *{
                color: #000;
            }
        }

        &_image{
            position: absolute;
            z-index:1;
            left: 0;
            width: 100%;
            top: 0;
            height: 100vh;
            background-size: cover;
            background-position: center center;
        }

        &_caption {
            font-size: 1.5rem;
            position: absolute;
            bottom: 0;
            left: calc(30% - 30rem);
            padding: $G-default;
            width: 30rem;
            text-align: right;
        }

        &_content{
            width: 50%;
            margin-left: calc(50% + 3rem);
            padding-left: $G-default;
            padding-right: $G-default*4;
            overflow: hidden;
            position: relative;
            z-index: 2;

            @include breakpoint(xs){
                width: 100%;
                padding: 8rem $G-default*2;
                margin: 0;
            }

            h1{
                font-size: 7rem;
                line-height: 1.1em;
                font-weight: $FW-bold;
                text-transform: uppercase;
                margin-top: 5rem;

                @include breakpoint(lt-xl) {
                    font-size:6rem;
                }

                &.reduceSize {
                    font-size:6rem;
                    
                    @include breakpoint(lt-xxl) {
                        font-size:5rem;
                    }
                }
            }
            h2{
                font-family: $F-Montserrat;
                font-size: 2.5rem;
                font-weight: $FW-bold;
                text-transform: uppercase;
                margin-top: $G-default*2;

                @include breakpoint(lt-xl) {
                    margin-top: $G-default*1.5;
                }
            }



            &_intro{
                margin-top: $G-default;
            }
        }

        .author{
            margin-top: $G-default;
            opacity: 0;
        }

        .author_list {
            opacity: 0;

            @include breakpoint(pano-high) {
                display: none;
            }
        }

        &-half {
            .articleTop_caption {
                z-index: $ZI-scrolldown;
                width: 100%;
                max-width: 25%;
                text-align: left;
                background-color: rgba(0, 0, 0, 0.5);
                padding: 1.5rem 20rem 1.5rem 2rem;
                font-size: 1.5rem;
                color: #ffffff;
                background: linear-gradient(-90deg, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0.1) 40%, rgba(0, 0, 0, 0.3) 60%, rgba(0, 0, 0, 0.7) 100%,);
                box-sizing: border-box;
                left:0;
                bottom:0;
            }
        }

    }
</style>